import { createSlice } from "@reduxjs/toolkit";
import { sendGeneralRequest, setToken } from "../generalRequest";

const initialState = {
    isLoading: false,
    isRequestSuccessfullySent: false
}

export const forgotUserAccountSlice = createSlice({
    name: 'forgotUserAccount',
    initialState,
    reducers:{
        setIsRequestSuccessfullySent : (state, action) => 
        {   
            state.isRequestSuccessfullySent = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendGeneralRequest.pending, (state) => {
                state.isLoading = true
            }) 
            .addCase(sendGeneralRequest.rejected, (state) => {
                state.isLoading = false
            }) 
            .addCase(sendGeneralRequest.fulfilled, (state, action) => {
                state.isLoading = false
                if(action.payload.endpoint === 'UserLostAccount')
                {         
                    state.isRequestSuccessfullySent = true    
                }
            })
        }
})

export const { setIsRequestSuccessfullySent } = forgotUserAccountSlice.actions;

export const selectForgotUserAccountState = (state) => state.forgotUserAccount;

export default forgotUserAccountSlice.reducer;